import { z } from 'zod';
import { StatBonusSchema } from '../data/items.js';
import { PhraseFieldsSchema } from './phrase.js';
/**
 * The smith (ADR 0013). The client names the piece and nothing else: the
 * server knows where the player stands, what the next step costs, and rolls.
 */
export const UpgradeItemMessageSchema = z.object({ itemId: z.uuid() });
/** To the owner alone, after the attempt; the new inventory follows. */
export const UpgradeResultSchema = z.object({
    outcome: z.enum(['success', 'fail']),
    itemId: z.uuid(),
    templateId: z.string().min(1),
    /** Level after the attempt: one more on success, unchanged otherwise. */
    level: z.number().int().min(0).max(10),
    /** The chance that was applied, in percent. */
    chance: z.number().int().min(1).max(100),
    /** The piece's stats at its level now. */
    bonus: StatBonusSchema,
    bound: z.boolean(),
});
export const UPGRADE_REFUSALS = [
    'invalid',
    'unknown-item',
    'not-upgradeable',
    'max-level',
    'missing-materials',
    'missing-gold',
    'too-far',
    'rate-limited',
    /** The camp's smith works the rare sword of the lesson only (ADR 0078). */
    'camp',
];
export const UpgradeRejectedSchema = z.object({
    reason: z.enum(UPGRADE_REFUSALS),
    /** Milliseconds until the next attempt is accepted, when rate-limited. */
    retryInMs: z.number().int().min(0).optional(),
});
/**
 * A server line for everyone in the room, drawn apart from what players say.
 * `text` is the French; a line with values also carries its template and
 * values (`key`, `params`) for a client in another language (ADR 0069).
 */
export const AnnouncementSchema = z
    .object({
    text: z.string().min(1).max(200),
    at: z.number().int().positive(),
})
    .extend(PhraseFieldsSchema.shape);
//# sourceMappingURL=upgrade.js.map